const labels = {
  featureAdditionalAmentities: 'Value Add',
  featureAddress: 'Location',
  featureAmenities: 'Amenities',
  featureAirport: 'Airport',
  featureDining: 'Dining',
  featureGeneral: 'General',
  featureParking: 'Parking',
  galleryFeatured: 'Featured',
  galleryImageSource: 'All images sourced from Leonardo',
  galleryMorePhotos: 'More Photos',
  detailsBtn: 'More Details'
}

export default labels
